"use client";

import { useEffect, useRef, useState } from "react";

export function LazyRender({ children }: { children: React.ReactNode }) {
  if (typeof window === "undefined") {
    return <div>{children}</div>;
  }

  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: "50px", // Start loading slightly before the item comes into view
      }
    );

    if (ref.current !== null) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [children]);

  return (
    <div ref={ref} className="min-h-[50px]">
      {isVisible ? children : null}
    </div>
  );
}
